import { claimableOpen, claims } from './claims.js';
import { settleDerived } from './derived.js';
import { roundHalfAway } from './rounding.js';
export const syncAmounts = (caseState) => {
    const claimsByLedger = claims(caseState);
    for (const entry of caseState.ledgerEntries) {
        writeAmount(entry, claimsByLedger);
    }
};
// Interest is what was paid and what can be claimed (D31).
export const writeAmount = (entry, claimsByLedger) => {
    const ledger = entry.ledger;
    if (ledger === null) {
        return;
    }
    settleDerived(entry);
    if (entry.kind === 'interest') {
        entry.voucher.amount =
            0 - (ledger.paid + claimableOpen(ledger, claimsByLedger?.get(ledger)));
    }
    else {
        entry.voucher.amount = entry.inputAmount + ledger.writtenOff;
    }
};
// What of the voucher was written off, by reason. Kept up to date at every
// breakpoint callback too, so its observers see write-offs as they happen.
export const writeWriteOffAmounts = (entry) => {
    settleDerived(entry);
    let expired = 0;
    let irrecoverable = 0;
    for (const tranche of entry.ledger.tranches) {
        if (tranche.pending) {
            continue;
        }
        if (tranche.reason === 'expired') {
            expired += tranche.writtenOff;
        }
        else if (tranche.reason === 'irrecoverable') {
            irrecoverable += tranche.writtenOff;
        }
    }
    expired -= roundHalfAway(entry.unclaimed.expired);
    irrecoverable -= roundHalfAway(entry.unclaimed.irrecoverable);
    entry.voucher.expiredAmount = expired;
    entry.voucher.irrecoverableAmount = irrecoverable;
};
//# sourceMappingURL=output.js.map